if (!customElements.get('product-details-tabs')) {
  class ProductDetailsTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event));
      });

      this.addEventListener('shopify:block:select', (event) => {
        const tab = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
        if (tab) this.selectTab(tab, false);
      });
    }

    selectTab(selectedTab, moveFocus = true) {
      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.classList.toggle('is-active', isSelected);
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isSelected = panel.id === selectedTab.getAttribute('aria-controls');
        panel.hidden = !isSelected;
        panel.classList.toggle('is-active', isSelected);
      });

      if (moveFocus) selectedTab.focus();
    }

    handleKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      this.selectTab(this.tabs[nextIndex]);
    }
  }

  customElements.define('product-details-tabs', ProductDetailsTabs);
}
